import { call, put, all, fork } from 'redux-saga/effects';
import { takeLatestAction } from 'Utils/sagaUtils';
import { deleteChapter, updateChapters, retrieveChapters } from 'Api/Chapters/chaptersService';
import { secondsToHHMMSS } from 'Utils/chapterHelper';
import { sendNotification } from '../Notification/actions';
import { deleteChapterAction, saveChapterAction, retrieveChaptersAction } from './actions';

function* deleteChapterSaga(action) {
  try {
    const { recordingId, chapterId } = action;
    yield call(deleteChapter, recordingId, chapterId);
    const result = {
      recordingId,
      deletedChapterId: chapterId
    };
    yield put({ type: deleteChapterAction.complete.toString(), payload: result });
    yield put(sendNotification(null, 'cards.chapters.notification.deleted', false));
  } catch (error) {
    yield put({ type: deleteChapterAction.failed.toString(), payload: error });
    yield put(sendNotification(null, 'cards.chapters.notification.deleteFailed', true));
  }
}

function* saveChapterSaga(action) {
  try {
    const { recordingId, chapters } = action;
    const data = yield call(updateChapters, recordingId, chapters);
    const newChapters = data.map((chapter) => ({
      chapterId: chapter.chapterId,
      chapterTitle: chapter.chapterTitle,
      chapterStartTimeSeconds: secondsToHHMMSS(chapter.chapterStartTimeSeconds)
    }));
    const draftChapters = newChapters.map((chapter) => ({ ...chapter }));
    const newChapter = {
      [recordingId]: newChapters
    };
    const draftChapter = {
      [recordingId]: draftChapters
    };
    const result = {
      draftChapter,
      newChapter
    };
    yield put({ type: saveChapterAction.complete.toString(), payload: result });
    yield put(sendNotification(null, 'cards.chapters.notification.saved', false));
  } catch (error) {
    yield put({ type: saveChapterAction.failed.toString(), payload: error });
    yield put(sendNotification(null, 'cards.chapters.notification.saveFailed', true));
  }
}

function* retrieveChaptersSaga(action) {
  try {
    const { recordingId } = action;
    const data = yield call(retrieveChapters, recordingId);
    const chapters = data.map((chapter) => ({
      chapterId: chapter.chapterId,
      chapterTitle: chapter.chapterTitle,
      chapterStartTimeSeconds: secondsToHHMMSS(chapter.chapterStartTimeSeconds)
    }));

    const draftChapters = chapters.map((chapter) => ({ ...chapter }));
    const newChapter = {
      [recordingId]: chapters
    };

    const draftChapter = {
      [recordingId]: draftChapters
    };

    const result = {
      draftChapter,
      newChapter
    };
    yield put({ type: retrieveChaptersAction.complete.toString(), payload: result });
  } catch (error) {
    yield put({ type: retrieveChaptersAction.failed.toString(), payload: error });
  }
}

export default function* rootSaga() {
  yield all([
    fork(takeLatestAction.bind(this, deleteChapterAction, deleteChapterSaga)),
    fork(takeLatestAction.bind(this, saveChapterAction, saveChapterSaga)),
    fork(takeLatestAction.bind(this, retrieveChaptersAction, retrieveChaptersSaga))
  ]);
}
